import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useSession } from "@/lib/hooks/use-session";
import { Bell, CircleUser } from "lucide-react";
import { useRouter } from "next/navigation";
import { ThemeToggle } from "../layout/ThemeToggle";
import AvatarInitials from "../shared/AvatarInitials";

export default function PersonArea() {
  const { user, updateUser } = useSession();
  const { push } = useRouter();

  return (
    <>
      <ThemeToggle />
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="mr-2">
            <Bell className="h-5 w-5" />
          </Button>
        </PopoverTrigger>
        <PopoverContent collisionPadding={15}></PopoverContent>
      </Popover>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="secondary"
            size="icon"
            className="rounded-full place-self-end"
          >
            <CircleUser className="h-5 w-5" />
            {user?.user_metadata?.first_name && (
              <AvatarInitials
                firstName={user?.user_metadata?.first_name}
                lastName={user?.user_metadata?.last_name}
                image={user?.user_metadata?.avatar_url}
              />
            )}
            <span className="sr-only">Toggle user menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>{user && user.email}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem key="settings" onClick={() => push("/settings")}>
            Settings
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem key="logout" onClick={() => push("/logout")}>
            Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
